/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';

export const SubLinkContainer = styled.div<{ customMarginLeft?: string; borderLeft?: boolean }>`
  /* Section items line up with their header, as in Settings; only nested lists (categories) indent. */
  margin-left: ${(props) => props.customMarginLeft || '0'};
  display: flex;
  flex-direction: column;
  ${({ borderLeft, theme }) => (borderLeft ? `border-left: 1px solid ${theme.color.border};` : '')}
`;
